import { APIImobsaleUrl, APICadimo5Url } from "../../../config/constants";
export const API_VENDAS = `${APIImobsaleUrl}`;
export const API_CADIMO5 = `${APICadimo5Url}`;